import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { literalTypeValuesAndTypeValue } from "../../primitives";
import { idValidator } from "../misc/id-validator";
export const stateIdValidator = idValidator("state");
export const stateValidator = T.model("state", T.object({
    typeName: T.literal("state"),
    id: stateIdValidator,
    derivation: T.nullable(T.object({
        message: T.string,
        derivation: T.string
    })),
    locked: T.boolean,
    nonRemovable: T.boolean.optional(),
    // Origin?
    // path: T.string,
    defaultValue: literalTypeValuesAndTypeValue
}));
export const SWStateRecordType = createRecordType("state", {
    migrations: defineMigrations({}),
    validator: stateValidator,
    scope: "document"
}).withDefaultProperties(()=>({
        locked: false,
        derivation: null
    }));
export const castStateId = (id)=>{
    return {
        toStateValueId: ()=>{
            let parts = id.split(":");
            parts[0] = "state_value";
            return parts.join(":");
        }
    };
};
/** @public */ export function createStateId(id) {
    return `state:${id ?? nanoid()}`;
}
export function createState(state) {
    return {
        ...state,
        id: createStateId(state.id)
    };
}
export function isState(record) {
    if (!record) return false;
    return record.typeName === "state";
}
/** @public */ export function isStateId(id) {
    return SWStateRecordType.isId(id);
}
